<template>
<div>
  <div class="row">
    <div class="container">
      <p id="toc">
      </p>
      <hr/>
      <h1 id="jsonconst">JSON Konstanten</h1>
      <h2 id="docsource">Dokumenten-Herkunft</h2>
      <ul>
        <li>0 = bShop</li>
        <li>1 = iMoss</li>
        <li>2 = iFair</li>
        <li>3 = iHand</li>
        <li>4 = REST API Connector</li>
      </ul>
      <h2 id="docstatus">Übermittlungsstatus</h2>
      <ul>
        <li>0 = Neu</li>
        <li>1 = Gesendet ohne WaWi Eintrag mit E-Mail</li>
        <li>2 = Gesendet und eingetragen</li>
        <li>3 = Fehler bei Übermittlung</li>
      </ul>
      <hr/>
      <h1 id="jsondata">JSON Datenpräsentation</h1>
      <p>
        In den HTTP Schnittstellen vom bShop2 und iHand/iFair gibt es die Möglichkeiten die Informationen und Daten aus dem System umfänglich abzufragen. Eine kurze Erläuterung der Attribute und Datenformate folgt.
      </p>
      <div class="form-group">
        <label>Datenobjekt wählen:</label>
        <select @change="showType()" v-model="selType" class="form-control">
          <option v-for="t in typeList" :key="t" :value="t">{{ t }}</option>
        </select>
      </div>
      <div class="form-group">
        <button onclick="showAllTypes();" class="btn btn-primary">Alle Anzeigen</button>
      </div>
      <div class="container-fluid">
        <h2>{{ data.cname }}</h2>
        <div class="row">
          <div class="alert alert-primary">
            {{ data.comment }}
          </div>
        </div>
        <div class="container" v-if="data.super">
          <h6>{{ data.super.cname }} - Attribute</h6>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Attribute</th>
                <th>Datentyp</th>
                <th>Bemerkung</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,key) in data.super.attr" :key="key">
                <td>
                  <strong>{{ item.jname }}</strong>
                </td>
                <td>
                  <label>{{ item.type }}</label>
                </td>
                <td>
                  <label>{{ item.comment }}</label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="container">
          <h5>{{ data.cname }} - Attribute</h5>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Attribute</th>
                <th>Datentyp</th>
                <th>Bemerkung</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,key) in data.attr" :key="key">
                <td>
                  <strong>{{ item.jname }}</strong>
                </td>
                <td>
                  <label>{{ item.type }}</label>
                </td>
                <td>
                  <label>{{ item.comment }}</label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <script type="text/template" id="dtemp">
  </script>
</div>
</template>

<script>
import config from '@/modules/config.js'

export default {
  name: 'JsonDataView',
  data() {
    return {
      typeList: [],
      selType: '',
      data: {},
    }
  },
  created: function() {
    this.fetchTypes();
  },
  methods: {
    showType() {
      console.log(this.selType);
      var self = this;
      config.get(this,config.baseUrl + 'rest/datamap/jsonmeta/' + encodeURIComponent(this.selType),'Metabeschreibung laden',function(data) {
        console.log(data);
        self.data = data;
      })
    },
    fetchTypes() {
      var self = this;
      config.get(this,config.baseUrl + 'rest/datamap/jsontypes','Datentypen laden',function(data) {
        console.log(data);
        self.typeList = data;
      })
    }
  }
}
</script>
